const state = {
    material: 'economic', // economic, good, premium
    hoverMaterial: null,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  setMaterial(state, material) {
    state.material = material
  },
  setHoverMaterial(state, hoverMaterial) {
      state.hoverMaterial = hoverMaterial
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}